import { render } from "./PortfolioComponent.vue?vue&type=template&id=1ac0a614&scoped=true&ts=true"
import script from "./PortfolioComponent.vue?vue&type=script&lang=ts"
export * from "./PortfolioComponent.vue?vue&type=script&lang=ts"

import "./PortfolioComponent.vue?vue&type=style&index=0&id=1ac0a614&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac0a614"]])

export default __exports__